<script>
// import pickBy from "lodash/pickBy";
export default {
  name: "notifications",
  data() {
    return { interval: null };
  },
  created() {
    // this.getNotifications();
    // this.intervalSetup();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    // available() {
    //   return pickBy(this.notifications.groups, val => {
    //     return val.count > 0;
    //   });
    // },
    notifications() {
      return this.$store.getters["notifications/entries"];
    },
    panelStatus() {
      return this.$store.getters["notifications/panelStatus"];
    }
  },
  watch: {
    panelStatus(status) {
      this.panelStatusListeners(status);
    },
    $route() {
      // clear alert on location change
      this.closePanel();
    }
  },
  methods: {
    panelStatusListeners(status) {
      // const isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
      // const eventTypes = isTouch ? ["touchstart", "click"] : ["click"];
      if (status) {
        let self = this;
        this.clickEvt = function() {
          self.closePanel();
        };
        this.escapeEvent = function(event) {
          if (event.which == 27) self.closePanel();
        };
        this.stopProp = function(event) {
          event.stopPropagation();
        };
        // eventTypes.forEach(e => this.$el.addEventListener(e, this.stopProp));
        // eventTypes.forEach(e => document.addEventListener(e, this.clickEvt));
        this.$el.addEventListener("click", this.stopProp);
        document.addEventListener("click", this.clickEvt);
        document.addEventListener("keyup", this.escapeEvent);
      } else {
        // eventTypes.forEach(e => this.$el.removeEventListener(e, this.stopProp));
        // eventTypes.forEach(e => document.removeEventListener(e, this.clickEvt));
        this.$el.removeEventListener("click", this.stopProp);
        document.removeEventListener("click", this.clickEvt);
        document.removeEventListener("keyup", this.escapeEvent);
      }
    },
    clicked(post) {
      console.log("clicked");
      this.$router.push({ path: `/application/${post.target}/` });
      this.markUsed(post);
      this.closePanel();
    },
    markUsed(post) {
      console.log(post);
    },
    deleteNotification(group, post) {
      console.log(post);
    },
    getNotifications() {
      this.$store.dispatch("notifications/getNotifications");
    },
    intervalSetup() {
      this.interval = setInterval(
        function() {
          this.getNotifications();
        }.bind(this),
        30000
      );
    },
    closePanel() {
      this.$store.dispatch("notifications/closePanel");
    }
  }
};
</script>

<template>
  <div id="sapp__notifications" :class="{ isActive: panelStatus }">
    <div class="notifications-head has-background-primary">
      <div class="side left-side">
        <i
          class="sappfont sappfont-arrow-left is-size-4"
          @click="closePanel"
        ></i>
        <span class="title is-5">Notificaciones</span>
      </div>
      <div class="side right-side">
        <button class="button is-small" @click="getNotifications">
          Update
        </button>
      </div>
    </div>
    <div class="notifications-timeline">
      <div
        v-for="(group, groupName) in notifications.groups"
        :key="groupName"
        class="hentries-group"
      >
        <div class="group__header">{{ group.groupLabel }}</div>
        <ul class="group__list hfeed list">
          <li
            v-for="post in group.groupPosts"
            :key="post.id"
            class="hentry"
            :data-hentry="post.id"
            :data-notification-state="post.state"
          >
            <a class="boxlink" @click="clicked(post)">
              <span class="content">
                <span class="hentry-message">{{ post.message }}</span>
                <time class="date dt-published" :datetime="post.date">{{
                  post.date
                }}</time>
              </span>
            </a>
            <span
              class="delete is-medium"
              @click.prevent="deleteNotification(groupName, post.id)"
            >
              <!-- <span class="wrap">x</span> -->
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@media only screen {
  #sapp__notifications {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    background-color: #fff;
    z-index: 11;
    // transition: all 200ms;
    transition: all 0.15s cubic-bezier(0.075, 0.82, 0.165, 1);
    user-select: none;
    &.isActive {
      transform: translate3d(0%, 0px, 0);
      opacity: 1;
    }
    &:not(.isActive) {
      transform: translate3d(100%, 0px, 0);
      // opacity: 0;
      // visibility: hidden;
      pointer-events: none;
    }
  }
  .notifications-head {
    padding: 0.5rem;
    padding-left: 1rem;
    // background-color: #00bda5;
    // background-image: linear-gradient(-303deg, #00a4bd, #00afb2 56%, #00bda5);
    // background: linear-gradient(180deg, #32067c, #4608ad);
    color: #fff;
    display: flex;
    justify-content: space-between;
    height: 4rem;
    align-items: center;
    .side {
      display: flex;
      align-items: center;
    }
    .title {
      margin: 0;
      color: #fff;
    }
    .sappfont-arrow-left {
      margin-right: 0.5rem;
    }
  }
  .notifications-timeline {
    position: absolute;
    width: 100%;
    top: 4rem;
    bottom: 0;
    overflow-y: auto;
    scroll-behavior: smooth;
    will-change: scroll;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    .list {
      position: relative;
      display: block;
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .group__header {
      border-bottom: 1px solid #eaf0f6;
      fill: #516f90;
      color: #516f90;
      /*color: #33475b;*/
      font-weight: 600;
      font-size: 0.875rem;
      font-size: 0.8125rem;
      font-size: 0.75rem;
      padding: 0.5em 1.25em;
      width: 100%;
      background-color: #fafafa;
      position: sticky;
      top: 0;
      z-index: 1;
    }
  }
  .hentry {
    display: block;
    position: relative;
    font-size: 0.875rem;
    border-bottom: 1px solid #eaf0f6;
    transition: opacity 400ms;
    background: hsla(210, 60%, 96%, 1);
    .boxlink {
      display: block;
      padding: 1rem;
    }
    .content {
      position: relative;
      display: block;
      padding-right: 3rem;
    }
    .hentry-message {
      display: block;
      color: #33475b;
    }
    .date {
      display: block;
      color: #99acc2;
      font-size: 0.75rem;
    }
    .delete {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
    }
  }
  .hentry[data-notification-state="used"] {
    background: #fff;
  }
  @media only screen and (max-width: 39.9375em) {
    #sapp__notifications {
      bottom: 4rem;
    }
  }
  @media (min-width: 40em) {
    #sapp__notifications {
      left: initial;
      width: 25rem;
    }
    #sapp__notifications.isActive {
      box-shadow: -3px 0 8px 0 rgba(66, 91, 118, 0.21);
    }
  }
  @media (min-width: 48em) {
    #sapp__notifications {
      left: initial !important;
      width: 25rem !important;
    }
  }
}
</style>
